import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const vehicleDetailsSearchApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'vehicleDetailsSearchApi',
  tagTypes: [
    'VehicleDetailsSearch',
    'VehicleDetailsCreate',
    'VehicleDetailsUpdate',
    'VehicleDetailsDelete',
    'VehicleList'
  ],
  endpoints: () => ({})
})

export default vehicleDetailsSearchApi
